import './../../scss/blocks/_reviews.scss'
import initReviewsModal from '../components/reviewsModal'

const initReviewsSlider = () => {
    const sections = document.querySelectorAll('.reviews')
    if (!sections.length) {
        return
    }

    sections.forEach((section) => {
        const sliderEl = section.querySelector('.reviews__slider')
        const paginationEl = section.querySelector('.reviews__pagination')
        const prevEl = section.querySelector('.reviews__nav-btn--prev')
        const nextEl = section.querySelector('.reviews__nav-btn--next')

        if (!sliderEl) {
            return
        }

        const args = {
            slidesPerView: 1,
            spaceBetween: 16,
            speed: 450,
            watchOverflow: true,
            navigation: {
                prevEl,
                nextEl,
            },
            pagination: {
                el: paginationEl,
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    spaceBetween: 24,
                },
            },
        }

        // eslint-disable-next-line no-undef
        sliderEl._swiper = new Swiper(sliderEl, args)
    })
}

document.addEventListener('DOMContentLoaded', () => {
    initReviewsModal()
    initReviewsSlider()
})

